import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/filter/car.svg'


const _withScopeId = n => (_pushScopeId("data-v-f824f5bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "infoVeiculo",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\" data-v-f824f5bc><div class=\"d-flex flex-row\" data-v-f824f5bc><div id=\"imgBack\" data-v-f824f5bc><img src=\"" + _imports_0 + "\" alt=\"\" data-v-f824f5bc></div><div class=\"d-flex flex-column\" data-v-f824f5bc><span class=\"modal-title\" id=\"exampleModalLongTitle\" data-v-f824f5bc> Informações do veículo </span><p data-v-f824f5bc>Veja mais detalhes sobre o veículo</p></div></div><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-f824f5bc>X</button></div>", 1)
const _hoisted_6 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_7 = {
  id: "divCol",
  class: "d-flex flex-row gap-5 mb-4"
}
const _hoisted_8 = {
  class: "d-flex flex-column",
  style: {"width":"13.4rem"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Código", -1))
const _hoisted_10 = {
  class: "d-flex flex-column",
  style: {"width":"13.4rem"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fipe", -1))
const _hoisted_12 = {
  class: "d-flex flex-column",
  style: {"width":"13.4rem"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ordem", -1))
const _hoisted_14 = {
  class: "d-flex flex-column",
  style: {"width":"13.4rem"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Prioridade", -1))
const _hoisted_16 = {
  id: "divCol",
  class: "d-flex flex-row gap-5 mb-4"
}
const _hoisted_17 = {
  class: "d-flex flex-column",
  style: {"width":"16.8rem"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Marca", -1))
const _hoisted_19 = {
  class: "d-flex flex-column",
  style: {"width":"16.8rem"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Modelo", -1))
const _hoisted_21 = {
  class: "d-flex flex-column",
  style: {"width":"10rem"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ano 1", -1))
const _hoisted_23 = {
  class: "d-flex flex-column",
  style: {"width":"10em"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ano 2", -1))
const _hoisted_25 = { class: "d-flex flex-column mb-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Link do manual", -1))
const _hoisted_27 = { class: "btnSave d-flex w-100 justify-content-end" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19.3724 4.37237L15.6276 0.627634C15.2258 0.22577 14.6807 2.97177e-06 14.1124 0H2.14286C0.959375 0 0 0.959375 0 2.14286V17.8571C0 19.0406 0.959375 20 2.14286 20H17.8571C19.0406 20 20 19.0406 20 17.8571V5.88759C20 5.31927 19.7742 4.77423 19.3724 4.37237ZM10 17.1429C8.42205 17.1429 7.14286 15.8637 7.14286 14.2857C7.14286 12.7078 8.42205 11.4286 10 11.4286C11.5779 11.4286 12.8571 12.7078 12.8571 14.2857C12.8571 15.8637 11.5779 17.1429 10 17.1429ZM14.2857 3.54821V8.03571C14.2857 8.33156 14.0458 8.57143 13.75 8.57143H3.39286C3.09701 8.57143 2.85714 8.33156 2.85714 8.03571V3.39286C2.85714 3.09701 3.09701 2.85714 3.39286 2.85714H13.5946C13.7367 2.85714 13.873 2.91357 13.9734 3.01406L14.1288 3.16942C14.1785 3.21916 14.218 3.27821 14.2449 3.34321C14.2719 3.4082 14.2857 3.47786 14.2857 3.54821Z" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateSend && _ctx.updateSend(...args))),
              class: "d-flex flex-column"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.CarUpdated.codModelo) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.codModelo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.CarUpdated.fipe) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.fipe]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.CarUpdated.ordem) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.ordem]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.CarUpdated.prioridade) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.prioridade]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.CarUpdated.marca) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.marca]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.CarUpdated.modelo) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.modelo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.CarUpdated.ano) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.ano]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.CarUpdated.ano2) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.CarUpdated.ano2]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.CarUpdated.manual) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.CarUpdated.manual]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_Button, {
                  type: "submit",
                  variant: "primary",
                  text: "Salvar"
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}